export const IaptWork = "IaptWork";
export const IaptHomeManagement = "IaptHomeManagement";
export const IaptSocialLeisureActivities = "IaptSocialLeisureActivities";
export const IaptPrivateLeisureActivities = "IaptPrivateLeisureActivities";
export const IaptFamilyAndRelationships = "IaptFamilyAndRelationships";
